<template>
    <div class="d-flex info-card">
        <div
            class="d-none d-lg-flex flex-column justify-content-center align-items-center mr-2"
        >
            <avatar
                :size="84"
                slot="aside"
                class="avatar"
                :src="user.picture"
                :username="user.name"
            />
            <div class="status-badge">
                <b-badge
                    pill
                    :style="{ background: user.status.color }"
                    v-b-popover.hover="
                        $t('status.' + user.status.name + '.description')
                    "
                    >{{ $t('status.' + user.status.name + '.name') }}</b-badge
                >
            </div>
        </div>
        <div class="mt-2">
            <div class="d-flex flex-column">
                <div class="d-flex">
                    <h5 class="m-0 mr-2">
                        {{ user.name }}
                    </h5>
                    <b-badge
                        pill
                        class="d-lg-none mt-1"
                        :style="{ background: user.status.color }"
                        v-b-popover.hover="
                            $t('status.' + user.status.name + '.description')
                        "
                        >{{
                            $t('status.' + user.status.name + '.name')
                        }}</b-badge
                    >
                </div>
                <h6 class="mt-1 mb-0 section-name">
                    {{ user.sections[0].name }}
                </h6>
            </div>
            <div class="d-flex flex-column name-manager">
                <div class="d-flex">
                    <i class="icon fa fa-envelope"></i>
                    <span>{{ user.email }}</span>
                </div>
                <div class="d-flex" v-if="user.manager.name">
                    <i class="icon fas fa-user-tie mr-1" />
                    <b-link
                        v-if="userCanSeeLinkToManagerProfile()"
                        style="color: #a1a8af"
                        :to="`/v2/profile/${this.user.manager.id}`"
                        >{{ user.manager.name }}</b-link
                    >
                    <span v-else>{{ user.manager.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
    name: 'UserData',
    components: {
        Avatar,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        currentUser: {
            type: Object,
            required: true,
        },
    },
    methods: {
        userCanSeeLinkToManagerProfile() {
            if (
                this.currentUser.id == this.user.manager.id ||
                (this.currentUser.id == this.user.id &&
                    this.currentUser.is_allowed_to_access_manager_profile) ||
                this.currentUser.role.name === 'administrator'
            ) {
                return true
            }
        },
    },
}
</script>

<style scoped lang="css">
.card-background {
    width: 100%;
    display: flex;
    min-height: 130px;
    margin-left: auto;
    align-items: center;
}

.info-card {
    overflow-wrap: anywhere;
}

.status-badge {
    top: -12px;
    position: relative;
}

.name-manager {
    color: #a1a8af;
    font-size: 0.8rem;
    font-weight: 500;
}

.section-name {
    color: #009bdb;
    font-weight: 600;
}

.icon {
    margin-top: 5px;
    margin-right: 4px;
}

.fa,
.fas {
    color: #35b1dd;
}

.badge {
    color: #fff;
    max-width: 50px;
    max-height: 17px;
}

@media (min-width: 992px) {
    .card-background {
        width: 92%;
    }
}

@media (min-width: 1500px) {
    .avatar-status {
        left: 14px;
    }
}
</style>
